import React, { useEffect, useState, useContext, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import Image from 'next/image';
import Link from 'next/link';
import { Box, Typography, Drawer } from '@mui/material';
import { CHANGE_LANG, SET_CATEGORIES } from 'context/actions/system';
import { logoutAccount } from 'context/actions/auth';
import { uploadImage, updateMyProfile } from 'context/actions/accounts';
import { getProductList } from 'context/actions/product';
import ProductCard from './cards/ProductCard';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';

import { signOut } from 'next-auth/react';

// utils
import useWindowSize from 'utils/useWindowSize';

import { SHOW_DEVELOP } from 'context/actions/system';
import { SHOW_LOADING, SET_ALERT } from 'context/actions/system';
import { setAccount } from 'context/actions/auth';

import MenuDrawerItem from './MenuDrawerItem';
import MenuDrawerSubItem from './MenuDrawerSubItem';
import MenuItem from './MenuItem';
import MenuSubItem from './MenuSubItem';
import EditProfileCompose from './EditProfileCompose';
import PasswordChangeCompose from './PasswordChangeCompose';

import {
    X,
    Menu as MenuIcon,
    ChevronLeft,
    User,
    Truck,
    Lock,
    LogOut,
    Search,
    ShoppingBag,
} from 'react-feather';

//actions

import { getAdsList } from 'context/actions/ads';

function useOutsideClick(ref, secondRef, callback) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (
                ref.current &&
                !ref.current.contains(event.target) &&
                (!secondRef ||
                    (secondRef.current &&
                        !secondRef.current.contains(event.target)))
            ) {
                callback();
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, callback]);
}

const Header = () => {
    const { sizes } = useWindowSize();
    const { t } = useTranslation();
    const router = useRouter();
    const langRef = useRef();
    const menuRef = useRef();
    const searchRef = useRef();
    const searchButtonRef = useRef();
    const mainMenuRef = useRef();
    const accountMainMenuRef = useRef();
    const accountMenuRef = useRef();

    const [isShowAccountMenus, setShowAccountMenus] = useState(false);
    const [searchProducts, setSearchProducts] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [fadeClass, setFadeClass] = useState('opacity-100');
    const [subMenuLeftPosition, setSubMenuLeftPosition] = useState(0);

    const auth = useSelector((state) => state.auth);
    const system = useSelector((state) => state.system);
    const dispatch = useDispatch();

    const [showMenu, setShowMenu] = useState(false);
    const [searchValue, setSearchValue] = useState('');

    const [ads, setAds] = useState([]);
    const [chosedLang, setChoosedLang] = useState(null);
    const [isLoggedIn, setLoggedIn] = useState(false);
    const [showLangList, setShowLangList] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [showSubMenu, setShowSubMenu] = useState(false);
    const [subMenuDirection, setSubMenuDirection] = useState('column');
    const [subMenu, setSubMenu] = useState(null);
    const [isSearchLoader, setSearchLoader] = useState(false);
    const [isOpenRegister, setOpenRegitser] = useState(false);
    const [isOpenPasswordChange, setOpenPasswordChange] = useState(false);

    const [isEditProfile, setEditProfile] = useState(false);

    useOutsideClick(accountMainMenuRef, accountMenuRef, () => {
        setShowAccountMenus(false);
    });

    useOutsideClick(langRef, null, () => {
        setShowLangList(false);
    });

    useOutsideClick(searchRef, searchButtonRef, () => {
        setShowSearch(false);
    });

    useOutsideClick(menuRef, mainMenuRef, () => {
        setShowSubMenu(false);
        setSubMenu(null);
    });

    useEffect(() => {
        setSearchLoader(true);

        const fetchProducts = async () => {
            const res_product = await getProductList(
                `search=${searchValue}&limit=3`,
            );
            if (res_product.status === 'success') {
                setSearchProducts(res_product.data);
                setSearchLoader(false);
            }
        };

        const delayFn = setTimeout(() => {
            if (searchValue.length === 0) {
                setSearchValue('');
                setSearchProducts([]);
                setSearchLoader(false);
            }
            if (searchValue.length > 0 && searchValue.length < 50) {
                fetchProducts();
            }
        }, 500); // 500 миллисекунд (0.5 секунд)

        return () => clearTimeout(delayFn);
    }, [searchValue]);

    useEffect(() => {
        const interval = setInterval(() => {
            setFadeClass('opacity-0'); // Start fade-out

            setTimeout(() => {
                setCurrentIndex((prevIndex) => {
                    const newIndex = prevIndex + 1;
                    return newIndex;
                });

                setFadeClass('opacity-100'); // Start fade-in
            }, 500); // Match with transition duration
        }, 3000); // Total duration for one cycle

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (currentIndex === ads.length) setCurrentIndex(0);
    }, [currentIndex]);

    useEffect(() => {
        if (auth?.accountLoggedIn) setLoggedIn(true);
        else setLoggedIn(false);
    }, [auth]);

    useEffect(() => {
        getDatas();
    }, []);

    useEffect(() => {
        if (system.languages?.length) {
            system.languages.map((lng) => {
                if (lng.code === system.lang) setChoosedLang(lng);
            });
        }
    }, [system.languages]);

    const getDatas = async () => {
        const resAds = await getAdsList(`&isActive=1`);
        if (resAds.status === 'success') setAds(resAds.data);
    };

    const handleUserEdit = async (data, callback) => {
        dispatch({ type: SHOW_LOADING, data: true });

        if (isEditProfile) {
            let avatarId = null;

            // ✅ Хэрвээ шинэ зураг байвал upload хийх
            if (data.profileImageFile) {
                const formdata = new FormData();
                formdata.append('files', data.profileImageFile);

                const resultAvatar = await uploadImage(formdata);

                if (
                    resultAvatar?.status === 'success' &&
                    resultAvatar.data?.length
                ) {
                    avatarId = resultAvatar.data[0].id; // 👉 шинэ зураг upload хийсэн бол шинэ id-г хадгална
                }
            }

            // ✅ Хэрэглэгчийн мэдээлэл шинэчлэх
            const res = await updateMyProfile({
                ...data,
                avatarId,
                isAvatarChange: avatarId || !data.profileImage ? true : false,
            });

            if (res.status === 'success') {
                await setAccount(dispatch, { id: auth?.account?.accountId });
                dispatch({
                    type: SET_ALERT,
                    data: {
                        isShow: true,
                        type: 'success',
                        message: t('title.success_edit'),
                    },
                });
                setOpenRegitser(false);
            } else {
                if (res.message === 'mail_inserted') {
                    dispatch({
                        type: SET_ALERT,
                        data: {
                            isShow: true,
                            type: 'warning',
                            message: t('warning.mail_inserted'),
                        },
                    });
                } else if (res.message === 'mobile_inserted') {
                    dispatch({
                        type: SET_ALERT,
                        data: {
                            isShow: true,
                            type: 'warning',
                            message: t('warning.mobile_inserted'),
                        },
                    });
                } else
                    dispatch({
                        type: SET_ALERT,
                        data: {
                            isShow: true,
                            type: 'warning',
                            message: t('warning.unsuccessful'),
                        },
                    });
            }
        } else {
            if (data.profileImageFile) {
                const formdata = new FormData();
                formdata.append('files', data.profileImageFile);
                const resultAvatar = await uploadImage(formdata);

                if (
                    resultAvatar.status === 'success' &&
                    resultAvatar.data.length
                ) {
                    await createAccountProfile(
                        data,
                        resultAvatar.data[0].id,
                        callback,
                    );
                } else {
                    dispatch({
                        type: SET_ALERT,
                        data: {
                            isShow: true,
                            type: 'warning',
                            message: t('warning.register_unsuccessfully'),
                        },
                    });
                }
            } else await createAccountProfile(data, null, callback);
        }

        dispatch({ type: SHOW_LOADING, data: false });
    };

    const handleMenuButtonClick = () => {
        setShowMenu((prev) => !prev);
    };

    const handleDrawerClose = (force) => {
        if (force === true) {
            setShowMenu(false);
            setShowSubMenu(false);
        } else if (showSubMenu) setShowSubMenu(false);
        else {
            setShowMenu(false);
            setShowSubMenu(false);
        }
    };

    const closeEditCompose = () => {
        setOpenRegitser(false);
    };

    const closePasswordChange = () => {
        setOpenPasswordChange(false);
    };

    const handleRoteClick = (menu) => {
        showMenu && handleDrawerClose(true);

        // Урд нь '/'-тэй хадгалагдсан url-ийг нормчилж давхар '//' үүсгэхгүй.
        const target = menu.url
            ? '/' + menu.url.replace(/^\/+/, '')
            : '/content/' + menu.id;
        // Бүтээгдэхүүний хуудсан дээр байхад ангилал солих нь shallow (хуудас дахин ачаалахгүй).
        // Өөр хуудсанд байхад shallow нь үл тоомсорлогдож энгийн navigation болно.
        router.push(target, undefined, {
            shallow: target.startsWith('/products/'),
        });
    };

    const seeProduct = () => {
        setShowSearch(false);
        setSearchValue('');

        setSearchProducts([]);
        router.push(`/products/${searchProducts.list[0].category_id}`);
    };

    const handleSearchChange = (event) => {
        setSearchValue(event.target.value);
    };

    const handleClickSearch = (is_show_search, is_more, more_id) => {
        if (is_more === 'more') {
            router.push(`/products/more/${more_id}`);
        }
        setShowSearch(is_show_search);
        setSearchProducts([]);
        setSearchValue('');
        setSearchLoader(false);
    };

    const LanguageChanger = ({ style }) => {
        return (
            <Box
                ref={langRef}
                className={
                    'relative flex flex-row items-center cursor-pointer ' +
                    style
                }
                onClick={() => {
                    // дараагийн index авна (дараагийн хэл рүү шилжих)
                    const langs = system.languages;
                    const cIndex = langs.findIndex(
                        (lng) => lng.code === chosedLang?.code,
                    );
                    const nextIndex = (cIndex + 1) % langs.length;
                    const nextLang = langs[nextIndex];

                    setChoosedLang(nextLang);
                    i18n.changeLanguage(nextLang.code);
                    if (typeof window !== 'undefined') {
                        Cookies.set('chosen_lang', nextLang.code);
                    }
                    dispatch({
                        type: CHANGE_LANG,
                        data: nextLang.code,
                    });
                }}
            >
                <Image
                    width={24}
                    height={24}
                    src={chosedLang?.flagUrl}
                    alt=""
                    className="object-contain"
                    priority
                />
                <Box className={sizes.md ? 'mr-4' : ''}>
                    {!sizes.md && (
                        <Typography
                            variant={'body2'}
                            className="text-[#fff] !ml-2 !mr-6 w-[50px]"
                        >
                            {chosedLang?.name}
                        </Typography>
                    )}
                </Box>
            </Box>
        );
    };

    const AccountMenus = ({ className = '' }) => {
        if ((isShowAccountMenus || sizes.md) && auth.accountLoggedIn) {
            let menus = [
                {
                    type: 'link',
                    icon: <Truck size={16} className="text-gray-700" />,
                    linkName: 'orders',
                    name: t('title.my_orders'),
                },
                {
                    type: 'custom',
                    icon: (
                        <User
                            size={18}
                            className="text-gray-700 pr-[1px] -ml-[1px]"
                        />
                    ),
                    handleCustomClick: () => {
                        setEditProfile(true);
                        setOpenRegitser(true);
                    },
                    name: t('button.profile_edit'),
                },
                {
                    type: 'custom',
                    icon: (
                        <Lock
                            size={18}
                            className="text-gray-700 pr-[1px] -ml-[1px]"
                        />
                    ),
                    handleCustomClick: () => {
                        setOpenPasswordChange(true);
                    },
                    name: t('button.change_password'),
                },
                {
                    type: 'custom',
                    icon: <LogOut size={18} className="text-gray-700" />,
                    handleCustomClick: () => {
                        signOut();
                        logoutAccount(dispatch);
                        router.push('/');
                    },
                    name: t('button.logout'),
                },
            ];

            return (
                <Box
                    className={
                        `bg-paper border border-line ${!sizes.md && 'absolute z-[30] top-11 right-0 shadow-lg shadow-ink/5 min-w-[220px]'} flex flex-col justify-center items-start rounded-md p-1.5 ` +
                        className
                    }
                >
                    <ul
                        ref={accountMenuRef}
                        style={{
                            position: 'relative',
                        }}
                        className="w-full"
                    >
                        {menus.map((item, ind) => (
                            <React.Fragment key={ind}>
                                <li
                                    onClick={() => {
                                        if (item.type === 'custom') {
                                            if (sizes.md)
                                                handleDrawerClose(false);
                                            setShowAccountMenus(false);
                                            item.handleCustomClick();
                                        } else if (item.type === 'link') {
                                            if (sizes.md)
                                                handleDrawerClose(false);
                                            setShowAccountMenus(false);
                                            router.push('/' + item.linkName);
                                        }
                                    }}
                                    className={`
                                        rounded p-3 cursor-pointer h-9 flex items-center text-ink/80 transition-colors
                                        ${
                                            ind === menus.length - 1
                                                ? 'hover:bg-red-50 hover:text-red-600'
                                                : 'hover:bg-sand hover:text-ink'
                                        }
                                      `}
                                >
                                    <Box
                                        className={`flex items-center  justify-center ${sizes.md && 'p-2'} font-medium`}
                                    >
                                        {item.icon}
                                    </Box>
                                    <Typography
                                        noWrap
                                        variant={
                                            !sizes.md ? 'body14' : 'body18'
                                        }
                                        className={`${!sizes.md && '!p-2'} font-medium`}
                                    >
                                        {item.name}
                                    </Typography>
                                </li>
                            </React.Fragment>
                        ))}
                    </ul>
                </Box>
            );
        }
    };

    // ---- Хэл солих (system.languages жагсаалтаар дараагийн хэл рүү) ----------------
    const switchLang = () => {
        const langs = system.languages || [];
        if (!langs.length) return;
        const cIndex = langs.findIndex((lng) => lng.code === chosedLang?.code);
        const nextLang = langs[(cIndex + 1) % langs.length];
        setChoosedLang(nextLang);
        i18n.changeLanguage(nextLang.code);
        if (typeof window !== 'undefined')
            Cookies.set('chosen_lang', nextLang.code);
        dispatch({ type: CHANGE_LANG, data: nextLang.code });
    };

    // Одоогийн зам тухайн цэсэнд (эсвэл түүний дэд цэсэнд) хамаарах эсэх — доогуур зураас
    const menuTarget = (m) =>
        m.url ? '/' + m.url.replace(/^\/+/, '') : '/content/' + m.id;
    const isActiveMenu = (m) => {
        const target = menuTarget(m);
        const path = router.asPath.split('?')[0];
        if (path === target || path.startsWith(target + '/')) return true;
        return Boolean(m.children?.some((c) => isActiveMenu(c)));
    };

    const basketCount = auth?.account?.accountInfo?.basketCount || 0;
    const iconBtn =
        'relative inline-flex items-center justify-center w-8 h-9 rounded-full text-paper hover:text-paper/70 hover:bg-paper/10 transition-colors';
    const accountLabel = auth?.account?.accountInfo
        ? `${auth.account.accountInfo.lastName?.[0] || ''}.${auth.account.accountInfo.firstName || ''}`
        : '';

    // Mockup-ын давхарласан serif wordmark (цагаан)
    // CK лого (navy зураг тул navy дэвсгэр дээр цагаан болгож invert хийнэ) + давхарласан wordmark
    const wordmark = (
        <Link
            href="/"
            className="flex items-center gap-2.5 leading-none select-none"
            aria-label="Sor Cashmere"
        >
            <Image
                src="/logoo.png"
                alt=""
                width={38}
                height={40}
                priority
                className="w-[34px] h-[36px] sm:w-[38px] sm:h-[40px] object-contain brightness-0 invert"
            />
            <span className="flex flex-col items-start">
                <span className="font-serif font-semibold text-[26px] tracking-[0.12em] text-paper">
                    SOR
                </span>
                <span className="text-[8px] tracking-[0.42em] uppercase text-paper/80 -mt-0.5">
                    Cashmere
                </span>
            </span>
        </Link>
    );

    const basketButton = (
        <button
            type="button"
            aria-label="Basket"
            className={iconBtn}
            onClick={() => router.push('/basket')}
        >
            <ShoppingBag size={18} />
            {basketCount > 0 && (
                <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-paper text-ink text-[10px] leading-4 text-center">
                    {basketCount}
                </span>
            )}
        </button>
    );

    const langButton = (
        <button
            type="button"
            onClick={switchLang}
            aria-label="Language"
            className="inline-flex items-center gap-1.5 h-9 px-1.5 text-[13px] font-medium uppercase tracking-[0.15em] text-paper hover:text-paper/70 transition-colors"
        >
            {chosedLang?.flagUrl ? (
                <Image
                    width={16}
                    height={16}
                    src={chosedLang.flagUrl}
                    alt=""
                    className="object-contain"
                />
            ) : null}
            <span className="hidden">{chosedLang?.code}</span>
        </button>
    );

    return (
        <>
            {/* Navy sticky толгой — цагаан wordmark, цэс, icon */}
            <header className="sticky top-0 z-[40] bg-ink text-paper border-b border-paper/10">
                <div className="max-w-[1760px] mx-auto px-4 sm:px-6 lg:px-8 h-[64px] sm:h-[76px] flex items-center">
                    {sizes.md ? (
                        <>
                            <button
                                type="button"
                                aria-label="Menu"
                                className={`${iconBtn} -ml-2`}
                                onClick={handleMenuButtonClick}
                            >
                                <MenuIcon size={20} />
                            </button>
                            <div className="mx-auto">{wordmark}</div>
                            <div className="flex items-center -mr-2">
                                {basketButton}
                                {chosedLang && langButton}
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="mr-4 shrink-0">{wordmark}</div>
                            {/* Багтахгүй бол цэс хэвтээ гүйлгэгдэнэ (icon-уудтай давхцахгүй) */}
                            <nav
                                ref={mainMenuRef}
                                className="flex-1 min-w-0 overflow-x-auto no-scrollbar mr-3"
                            >
                                {/* Цэс header-ийн голд */}
                                <ul className="flex items-center justify-center gap-0 min-w-max mx-auto">
                                    {system.userMenus.map((m, ind) => (
                                        <MenuItem
                                            key={ind}
                                            menu={m}
                                            active={isActiveMenu(m)}
                                            onClick={(e) => {
                                                setSubMenu(m);
                                                setSubMenuDirection('column');
                                                setShowSubMenu(true);
                                                const rect =
                                                    e.currentTarget.getBoundingClientRect();
                                                setSubMenuLeftPosition(
                                                    parseInt(rect.left),
                                                );
                                            }}
                                        />
                                    ))}
                                </ul>
                            </nav>
                            <div className="flex items-center gap-0.5 -mr-2">
                                <button
                                    type="button"
                                    aria-label="Search"
                                    ref={searchButtonRef}
                                    className={iconBtn}
                                    onClick={() => handleClickSearch(true)}
                                >
                                    <Search size={18} />
                                </button>
                                {auth.accountLoggedIn ? (
                                    <div className="relative">
                                        <button
                                            type="button"
                                            ref={accountMainMenuRef}
                                            className="inline-flex items-center gap-2 h-9 px-1.5 text-paper/80 hover:text-paper transition-colors"
                                            onClick={() =>
                                                setShowAccountMenus(true)
                                            }
                                        >
                                            <span className="relative w-7 h-7 rounded-full overflow-hidden border border-paper/30 bg-paper/10">
                                                <img
                                                    src={
                                                        auth.account
                                                            ?.accountInfo
                                                            ?.photo ||
                                                        '/userDefault.svg'
                                                    }
                                                    alt=""
                                                    className="w-full h-full object-cover"
                                                />
                                            </span>
                                            <span className="hidden lg:inline text-[12px]">
                                                {accountLabel}
                                            </span>
                                        </button>
                                        <AccountMenus />
                                    </div>
                                ) : (
                                    <Link
                                        href="/login"
                                        aria-label={t('title.login')}
                                        className={iconBtn}
                                    >
                                        <User size={18} />
                                    </Link>
                                )}
                                {basketButton}
                                {chosedLang && langButton}
                            </div>
                        </>
                    )}
                </div>

                {/* Dropdown дэд цэс (desktop) */}
                {showSubMenu && subMenu && !sizes.md && (
                    <div
                        ref={menuRef}
                        className="absolute left-0 right-0 top-full z-[20] bg-paper border-b border-line shadow-lg shadow-ink/5"
                    >
                        <div className="max-w-[1760px] mx-auto px-4 sm:px-6 lg:px-8">
                            {subMenu?.children?.length > 0 && (
                                <ul
                                    style={{
                                        marginLeft: Math.max(
                                            0,
                                            subMenuLeftPosition - 24,
                                        ),
                                    }}
                                    className={`flex ${subMenuDirection === 'row' ? 'flex-row gap-8' : 'flex-col'} py-4`}
                                >
                                    {subMenu.children.map((m, ind) => (
                                        <MenuSubItem
                                            key={ind}
                                            menu={m}
                                            showsMenu={showSubMenu}
                                            onClick={() => {
                                                setShowSubMenu(false);
                                                setSubMenu(null);
                                            }}
                                        />
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                )}

                {/* Хайлт (desktop) */}
                {showSearch && !sizes.md && (
                    <div
                        ref={searchRef}
                        className="absolute left-0 right-0 top-full z-[20] bg-paper border-b border-line shadow-lg shadow-ink/5"
                    >
                        <div className="max-w-[1000px] mx-auto px-4 sm:px-6 py-8">
                            <div className="flex items-center gap-3 border-b border-ink/30 pb-2">
                                <Search
                                    size={16}
                                    className="text-ink/60 shrink-0"
                                />
                                <input
                                    autoFocus
                                    type="text"
                                    placeholder={t('button.search')}
                                    value={searchValue}
                                    onChange={handleSearchChange}
                                    className="flex-1 bg-transparent outline-none text-[15px] text-ink placeholder:text-ink/40"
                                />
                                <button
                                    type="button"
                                    aria-label="Close"
                                    className="text-ink/50 hover:text-ink transition-colors"
                                    onClick={() => handleClickSearch(false)}
                                >
                                    <X size={16} />
                                </button>
                            </div>

                            {isSearchLoader ? (
                                <div className="pt-8 pb-4">
                                    <Image
                                        width={40}
                                        height={40}
                                        src={'/productLoading.gif'}
                                        alt=""
                                        style={{ objectFit: 'cover' }}
                                        priority
                                    />
                                </div>
                            ) : (
                                <>
                                    {searchProducts.list?.length > 0 && (
                                        <div className="flex flex-wrap gap-6 pt-8">
                                            {searchProducts.list.map((card) => (
                                                <div
                                                    key={card.id}
                                                    className="cursor-pointer"
                                                    onClick={() =>
                                                        handleClickSearch(
                                                            false,
                                                            'more',
                                                            card.id,
                                                        )
                                                    }
                                                >
                                                    <ProductCard
                                                        {...card}
                                                        ChosenlangCode={
                                                            system.lang
                                                        }
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    {searchProducts.list &&
                                        !searchProducts.list.length && (
                                            <p className="pt-8 text-[13px] text-stone">
                                                {t('title.no_result')}
                                            </p>
                                        )}
                                    {searchProducts.list?.length > 0 && (
                                        <button
                                            type="button"
                                            onClick={seeProduct}
                                            className="mt-8 text-[12px] text-ink border-b border-ink/30 hover:border-ink pb-0.5 transition-colors"
                                        >
                                            {t('title.all_see_products')}
                                        </button>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                )}
            </header>

            {/* Mobile drawer */}
            {sizes.md && (
                <Drawer
                    anchor="left"
                    onClose={handleDrawerClose}
                    open={showMenu}
                    transitionDuration={{ enter: 400, exit: 400 }}
                    variant="temporary"
                    PaperProps={{
                        sx: {
                            width: '100vw',
                            height: '100vh',
                            maxWidth: '100%',
                            backgroundColor: '#F8F6F1',
                        },
                    }}
                >
                    <Box className="flex flex-col flex-1 min-h-full font-philosopher">
                        <div className="flex items-center h-[64px] px-4 bg-ink text-paper border-b border-paper/10">
                            {showSubMenu ? (
                                <ChevronLeft
                                    size={22}
                                    className="text-paper"
                                    onClick={handleDrawerClose}
                                />
                            ) : (
                                <X
                                    size={22}
                                    className="text-paper"
                                    onClick={handleDrawerClose}
                                />
                            )}
                            <div
                                className="mx-auto"
                                onClick={() => handleDrawerClose(true)}
                            >
                                {wordmark}
                            </div>
                            <span className="w-[22px]" />
                        </div>

                        <div className="flex-1 px-6 py-4">
                            {!showSubMenu && (
                                <ul>
                                    {system.userMenus.map((m, ind) => (
                                        <MenuDrawerItem
                                            key={ind}
                                            menu={m}
                                            onClick={() => {
                                                if (
                                                    m.children &&
                                                    !m.children.length
                                                ) {
                                                    handleRoteClick(m);
                                                } else {
                                                    setSubMenu(m);
                                                    setShowSubMenu(true);
                                                }
                                            }}
                                        />
                                    ))}
                                </ul>
                            )}
                            {showSubMenu && (
                                <>
                                    <p className="text-[10px] uppercase tracking-[0.25em] text-stone mb-4 mt-2">
                                        {
                                            subMenu?.names?.find(
                                                (item) =>
                                                    item.langCode ===
                                                    i18n.language,
                                            )?.name
                                        }
                                    </p>
                                    <ul>
                                        {subMenu?.children?.map((m, ind) => (
                                            <MenuDrawerSubItem
                                                key={ind}
                                                menu={m}
                                                onClick={() =>
                                                    handleRoteClick(m)
                                                }
                                            />
                                        ))}
                                    </ul>
                                </>
                            )}

                            {!showSubMenu && (
                                <div className="mt-8 pt-6 border-t border-line">
                                    {auth.accountLoggedIn ? (
                                        <>
                                            <div className="flex items-center gap-3 mb-3">
                                                <span className="relative w-9 h-9 rounded-full overflow-hidden border border-line bg-sand">
                                                    <img
                                                        src={
                                                            auth.account
                                                                ?.accountInfo
                                                                ?.photo ||
                                                            '/userDefault.svg'
                                                        }
                                                        alt=""
                                                        className="w-full h-full object-cover"
                                                    />
                                                </span>
                                                <span className="text-[13px] text-ink">
                                                    {accountLabel}
                                                </span>
                                            </div>
                                            <AccountMenus className="w-full" />
                                        </>
                                    ) : (
                                        <button
                                            type="button"
                                            className="w-full h-11 rounded-full bg-ink text-paper text-[11px] uppercase tracking-[0.2em]"
                                            onClick={() => {
                                                handleDrawerClose(true);
                                                router.push('/login');
                                            }}
                                        >
                                            {t('title.login')}
                                        </button>
                                    )}
                                    <div className="flex items-center gap-2 mt-4">
                                        <button
                                            type="button"
                                            className="flex-1 h-11 border border-line text-[12px] text-ink inline-flex items-center justify-center gap-2"
                                            onClick={() => {
                                                handleDrawerClose(true);
                                                router.push('/search');
                                            }}
                                        >
                                            <Search size={15} />
                                            {t('button.search')}
                                        </button>
                                        <button
                                            type="button"
                                            className="flex-1 h-11 border border-line text-[12px] text-ink inline-flex items-center justify-center gap-2"
                                            onClick={() => {
                                                handleDrawerClose(true);
                                                router.push('/basket');
                                            }}
                                        >
                                            <ShoppingBag size={15} />
                                            {t('title.basket')}
                                            {basketCount > 0
                                                ? ` (${basketCount})`
                                                : ''}
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </Box>
                </Drawer>
            )}

            <EditProfileCompose
                open={isOpenRegister}
                isEdit={isEditProfile}
                editItem={auth?.account?.accountInfo}
                onSave={handleUserEdit}
                handleClose={closeEditCompose}
            />
            <PasswordChangeCompose
                open={isOpenPasswordChange}
                handleClose={closePasswordChange}
            />
        </>
    );
};

export default Header;
